import { BreakpointObserver } from '@angular/cdk/layout';
import { FlexibleConnectedPositionStrategy, GlobalPositionStrategy, Overlay, OverlayContainer, OverlayRef, RepositionScrollStrategy, ScrollDispatcher, ViewportRuler } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { TemplatePortal } from '@angular/cdk/portal';
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

/**
 * Opens a popup (tooltip) if the info icon was clicked.
 *
 * TODO: Decicde whether to use ngx-bootstrap tooltips or cdk overlays
 * Problem tooltip: Long text may cause positioning problems on small devices
 * Problem cdk: Complicated to place below header
 *
 * Example:
 * ```html
 * <app-info-popup>
 *   This text is shown in the popup (HTML is also possible)
 * </app-info-popup>
 * ```
 */
@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss']
})
export class InfoPopupComponent implements OnInit, AfterViewInit {
  // private overlayRef: OverlayRef;
  // private infoPopupPortal: TemplatePortal;

  // @ViewChild('infoPopupButton') public infoPopupButtonRef: ElementRef<HTMLButtonElement>;
  // @ViewChild('infoPopupPortal') public infoPopupPortalRef: TemplateRef<HTMLElement>;

  /**
   * Defines whether the popup is displayed above, below, left or right of the popup button.
   *
   * The default value is 'bottom'. If there are placement problems, it is recommended to tweak this value.
   */
  @Input()
  public popupPlacement: 'top'|'bottom'|'left'|'right' = 'bottom';

  @Input()
  public isWarning: boolean;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private breakpointObserver: BreakpointObserver,
    private viewportRuler: ViewportRuler,
    @Inject(DOCUMENT) private document: Document,
    private platform: Platform,
    private overlayContainer: OverlayContainer,
    private scrollDispatcher: ScrollDispatcher,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
  }

  public ngAfterViewInit() {
    // this.infoPopupPortal = new TemplatePortal(this.infoPopupPortalRef, this.viewContainerRef);
  }

  // public show() {
  //   this.overlayRef = this.overlay.create({
  //     positionStrategy: this.getFlexibleConnectedPositionStrategy(),
  //     scrollStrategy: new RepositionScrollStrategy(
  //       this.scrollDispatcher, this.viewportRuler, this.ngZone, {autoClose: false, scrollThrottle: 10}
  //     ),
  //     panelClass: 'scg-overlay-pane',
  //     hasBackdrop: true,
  //     backdropClass: 'cdk-overlay-transparent-backdrop'
  //   });

  //   this.overlayRef.attach(this.infoPopupPortal);

  //   this.overlayRef.backdropClick().subscribe(() => {
  //     this.hide();
  //   });

  //   // this.breakpointObserver.observe([
  //   //   `(orientation: portrait) and (max-width: ${dropdownModalBreakpoint})`,
  //   //   `(orientation: landscape) and (max-height: ${dropdownModalBreakpoint})`
  //   // ]).subscribe((state) => {
  //   //   if (state.matches) {
  //   //     this.overlayRef.updatePositionStrategy(this.getGlobalPositionStrategy());
  //   //     this.overlayRef.updateScrollStrategy(new BlockScrollStrategy(this.viewportRuler, this.document));
  //   //   }
  //   // });
  // }

  // public hide() {
  //   this.overlayRef.detach();
  // }

  // private getGlobalPositionStrategy(): GlobalPositionStrategy {
  //   const strategy = new GlobalPositionStrategy();
  //   strategy.centerHorizontally();
  //   strategy.centerVertically();
  //   return strategy;
  // }

  // private getFlexibleConnectedPositionStrategy(): FlexibleConnectedPositionStrategy {
  //   const strategy = new FlexibleConnectedPositionStrategy(this.infoPopupButtonRef,
  //     this.viewportRuler,
  //     this.document,
  //     this.platform,
  //     this.overlayContainer
  //   );
  //   strategy.withPositions([
  //     // Bottom right
  //     {originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top'},
  //     // Bottom left
  //     {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top'},
  //     // Top right
  //     {originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom'},
  //     // Top left
  //     {originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom'},
  //   ]);
  //   strategy.withLockedPosition(false);
  //   strategy.withPush(false);
  //   return strategy;
  // }
}
